import * as React from 'react';
import {Link} from 'react-router-dom';

export interface Props {
  url: string;
  external?: boolean;
  children?: React.ReactNode;
}

export function AdapterLink({url, external, children, ...restProps}: Props) {
  return external ? (
    <a href={url} target="_blank" rel="noopener noreferrer" {...restProps}>
      {children}
    </a>
  ) : (
    <Link to={url} {...restProps}>
      {children}
    </Link>
  );
}
